import { Field, Form, Formik } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
import { Moment } from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import SearchButton from 'shared/components/Table/actions-buttons/SearchButton';

interface Props {
  onSubmit: (values: DriverPendingSettlementsFiltersType) => Promise<any>;
  filters: DriverPendingSettlementsFiltersType;
}

export interface DriverPendingSettlementsFiltersType {
  dateFrom: Moment;
  dateTo: Moment;
}

const useStyles = makeStyles({
  datePicker: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#00163B',
      '& fieldset': {
        borderColor: '#9CD0FF',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#D6EBFF'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#9CD0FF'
      },
      '& input': {
        color: '#D6EBFF'
      }
    },
    '& .MuiInputLabel-root': {
      color: '#9CD0FF',
      '&.Mui-focused': {
        color: '#9CD0FF'
      },
    }
  }
});

export const DriverPendingSettlementsFiltersComponent = ({
  onSubmit,
  filters
}: Props) => {
  const classes = useStyles();

  return (
    <Formik<DriverPendingSettlementsFiltersType>
      initialValues={filters}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form className=" flex items-center gap-2">
          <Field
            component={DatePicker}
            label="Desde"
            name="dateFrom"
            inputVariant="outlined"
            margin="dense"
            className={classes.datePicker}
            format="DD/MM/YYYY"
          />
          <Field
            component={DatePicker}
            label="Hasta"
            name="dateTo"
            inputVariant="outlined"
            margin="dense"
            className={classes.datePicker}
            format="DD/MM/YYYY"
          />
          <SearchButton
            onClick={formik.submitForm}
            backgroundColor="#9CD0FF"
            hoverBackgroundColor="#9CD0FF"
            iconColor="#00163B"
            hoverIconColor="#00163B"
            hoverShadow="0 0 10px rgba(156, 208, 255, 0.8)"
          />
        </Form>
      )}
    </Formik>
  );
};
